
import { useParams } from "react-router-dom";

import { Box } from "@mui/material";
import { DisenioBodega } from "../../layout";
import { useInventarioXBodega } from "../../../hooks";
import { BuscadorSoloValor, CargandoMedio, FBAFuncion, FormIngresarProdBodega } from "../../components";
import { ModalFormUno } from "../../components/components/ModalFormUno";
import { useModalesStore } from "../../../store";
import { TablaStock } from "../../components/productos/inventario";




export const StockXBodega = () => {


    const { id } = useParams();
    const { inventarioXBodegaQuery, page, termino, chagePage, chageTermino } = useInventarioXBodega(id);
    const { changeEstadoModalUno } = useModalesStore(); 



    return (

        <DisenioBodega titulo="Stock de Bodega" add={false}>
            {(inventarioXBodegaQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Stock..." />
            :   <>
                <BuscadorSoloValor termino={termino} chageTermino={chageTermino} 
                    titulo='Buscar producto.' place='Buscar x nombre'
                />
                <TablaStock data={inventarioXBodegaQuery.data || []} page={page} chagePage={chagePage} />
                </>
            }

            <Box sx={{height:30}} />

            <FBAFuncion funcion={() => changeEstadoModalUno(true)} icono="plus" />
            <ModalFormUno titulo="Ingresar Producto" valor={{}} onClose={() => changeEstadoModalUno(false)}>
                <FormIngresarProdBodega />
            </ModalFormUno>
        </DisenioBodega>

    )
}
